export const MANAGE_LEADS_ALL_START = "MANAGE_LEADS_ALL_START";
export const MANAGE_LEADS_ALL_SUCCESS = "MANAGE_LEADS_ALL_SUCCESS";
export const MANAGE_LEADS_ALL_ERROR = "MANAGE_LEADS_ALL_ERROR";

export const GET_LEAD_BY_ID_START = "GET_LEAD_BY_ID_START";
export const GET_LEAD_BY_ID_SUCCESS = "GET_LEAD_BY_ID_SUCCESS";
export const GET_LEAD_BY_ID_ERROR = "GET_LEAD_BY_ID_ERROR";

export const DELETE_LEAD_BY_ID_START = "DELETE_LEAD_BY_ID_START";
export const DELETE_LEAD_BY_ID_SUCCESS = "DELETE_LEAD_BY_ID_SUCCESS";
export const DELETE_LEAD_BY_ID_ERROR = "DELETE_LEAD_BY_ID_ERROR";

export const FETCH_TOUR_LEAD_LANGAUAGE_START =
  "FETCH_TOUR_LEAD_LANGAUAGE_START";
export const FETCH_TOUR_LEAD_LANGAUAGE_SUCCESS =
  "FETCH_TOUR_LEAD_LANGAUAGE_SUCCESS";
export const FETCH_TOUR_LEAD_LANGAUAGE_ERROR =
  "FETCH_TOUR_LEAD_LANGAUAGE_ERROR";
